import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";

/**
 * <Breadcrumb breadcrumb={} handeOpenFolder={} currentFolder={} />
 **/
const Breadcrumb = (props) => {
  const crumbs = props.breadcrumb.map((folder) => {
    return props.currentFolder == folder.id ? (
      <li
        key={`bc-fldr-${folder.id}`}
        className="breadcrumb-item active"
        aria-current="page"
      >
        <FontAwesomeIcon icon={faFolderOpen} size="lg" color="lightblue" />
        <span className="pl-1">{folder.name}</span>
      </li>
    ) : (
      <li key={`bc-fldr-${folder.id}`} className="breadcrumb-item">
        <a
          href="#"
          onClick={() => {
            props.handleOpenFolder(folder.id);
          }}
        >
          <FontAwesomeIcon icon={faFolderOpen} size="lg" />
          <span className="pl-1">{folder.name}</span>
        </a>
      </li>
    );
  });
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">{crumbs}</ol>
    </nav>
  );
};

export default Breadcrumb;
